import { useContext } from 'react';

import { FeedbackDialogContext } from './feedback-dialog-context';

export const useOpenFeedbackDialog = () => {
  const { openFeedbackDialog } = useContext(FeedbackDialogContext);

  return openFeedbackDialog;
};
